/**
 * 未入力の警告が設定されたオブジェクトが空だった場合の挙動
 */
export enum RegisterAlertKinds {
  /** 一時保存は可能 */
  AllowRegisterAsTemporaryOnly = 1,
  /** 登録不可（一時保存も不可） */
  Abort = 2,
  /** 一時保存は可能（確認ダイアログ表示あり） */
  AllowRegisterAsTemporaryOnlyWithDialog = 3,
}
